import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Image, message } from 'antd';
import { useMsal, useAccount } from '@azure/msal-react';
import axios from 'axios';
import { scoutChatCenterServerUrl } from '../autoConfig';

const Login = () => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0]);
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    if (account) {
      // Automatically try to log in using the Microsoft account email
      localStorage.setItem(
        'username',
        JSON.stringify([
          {
            name: ['username'],
            value: account.username.toLowerCase()
          },
          {
            name: ['password'],
            value: ''
          }
        ])
      );
      handleLogin(account.username);
    }
  }, [account]);

  const handleLogin = async (email) => {
    try {
      const response = await axios({
        method: 'post',
        url: `${scoutChatCenterServerUrl}/chatSession/login`,
        data: {
          email: email.toLowerCase()
        }
      });
      if (response) {
        sessionStorage.setItem(
          'role',
          response.data.isTeamAdmin || response.data.isSysAdmin ? 'Admin' : ''
        );
        sessionStorage.setItem('consultantName', response.data.consultantName);
        console.log(
          `Consultant (${response.data.consultantName}) login successful.`
        );
        navigate('/chat');
      }
    } catch (error) {
      messageApi.open({
        type: 'error',
        content: error.response.data.message
          ? error.response.data.message
          : error.response.data
      });
      console.log('Error occurred during login process', error);
    }
  };

  const onMSALogin = () => {
    instance.loginRedirect();
  };

  return (
    <div
      className="h-[100vh] flex flex-col justify-center items-center"
      style={{ backgroundColor: 'rgb(0, 48, 67)' }}
    >
      <Image
        width={200}
        preview={false}
        src="https://scoutfroneasset.blob.core.windows.net/frontend-asset/new-scout-logo.png"
      />
      <p style={{ color: 'white', fontSize: '20px', marginBottom: '20px' }}>
        Scout Chat Center
      </p>
      <Button
        onClick={onMSALogin}
        size="large"
        style={{
          fontSize: '20px', // Larger font size
          padding: '0px 24px' // Larger padding
        }}
      >
        Login
      </Button>
      {contextHolder}
    </div>
  );
};

export default Login;
